<template>
  <div class="plant-wrapper">
    <div class="plant-wrapper-top">
      <div class="handle-wrapper" @click="backPath">
        <div class="icon-font">&#xe612;</div>
        返回
      </div>
      <div class="plant-wrapper-top-title">虫情板详情</div>
      <div class="handle-wrapper" style="opacity: 0">
        <div class="icon-font">&#xe612;</div>
        返回
      </div>
    </div>
    <div class="select-wrapper">
      <div class="look-select-top">
        <div class="look-select-top-item">虫情板ID：{{ pestBoardId }}</div>
        <div class="look-select-top-item">仓库位置：{{ siteName }}</div>
      </div>
      <div class="look-select-bottom">
        <div style="margin-right: 1vw">
          <DropDown
            content="请选择审核状态"
            :items="approveData"
            v-on:sendInfo="showInfoApprove"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            content="请选择处理状态"
            :items="handleData"
            v-on:sendInfo="showInfoHandle"
          ></DropDown>
        </div>
        <div style="margin-right: 1vw">
          <DropDown
            content="请选择垛位状态"
            :items="stackData"
            v-on:sendInfo="showInfoStack"
          ></DropDown>
        </div>
        <div class="input-date-wrapper">
          <el-date-picker
            v-model="value"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>
        <div class="query button" @click="handleSearch(1)">查询</div>
      </div>
    </div>
    <div class="detail">
      <div class="detail-box">
        <div class="loading-data" v-if="loading">
          <i class="el-icon-loading"></i>
          <div>加载中，请稍后···</div>
        </div>
        <div class="detail-nav">
          <div class="look-detail-item" style="width: 10%">序号</div>
          <div class="look-detail-item" style="width: 10%">害虫数量</div>
          <div class="look-detail-item" style="width: 10%">负责人</div>
          <div class="look-detail-item" style="width: 10%">记录日期</div>
          <div class="look-detail-item" style="width: 10%">处理状态</div>
          <div class="look-detail-item" style="width: 10%">审核状态</div>
          <div class="look-detail-item" style="width: 10%">申请状态</div>
          <div class="look-detail-item" style="width: 10%">垛位状态</div>
          <div class="look-detail-item" style="width: 20%">操作</div>
        </div>
        <div class="detail-content">
          <div
            class="detail-list-wrapper"
            v-if="!loading && tableData.length > 0"
            v-for="(data, index) in tableData"
            :key="index"
          >
            <div class="look-detail-list-data" style="width: 10%">
              {{ index + 1 }}
            </div>
            <div class="look-detail-list-data" style="width: 10%">
              {{ data.pestCount }}
            </div>
            <div class="look-detail-list-data" style="width: 10%">
              {{ data.principalName }}
            </div>
            <div class="look-detail-list-data" style="width: 10%">
              {{ data.createdTime }}
            </div>
            <div
              class="look-detail-list-data"
              style="width: 10%"
              :class="{
                'color-red': data.handleStatus === '未处理',
                'color-green': data.handleStatus === '已处理',
              }"
            >
              {{ data.handleStatus }}
            </div>
            <div
              class="look-detail-list-data"
              style="width: 10%"
              :class="{
                'color-red': data.approveStatus === '未审核',
                'color-green': data.approveStatus === '已审核',
              }"
            >
              {{ data.approveStatus }}
            </div>
            <div
              class="look-detail-list-data"
              style="width: 10%"
              :class="{
                'color-red': data.applyStatus === '未申请',
                'color-green': data.applyStatus === '已申请',
              }"
            >
              {{ data.applyStatus }}
            </div>
            <div class="look-detail-list-data" style="width: 10%">
              {{
                data.stackStatus === "01"
                  ? "需杀虫"
                  : data.stackStatus === "02"
                  ? "正常养护"
                  : "--"
              }}
            </div>
            <div class="look-detail-list-data operation" style="width: 20%">
              <div
                class="operation-item item-look"
                v-if="data.applyStatus === '已申请'"
                :class="{ 'item-look-active': data.deal === '0' }"
                @click="lookPlantDeal(data.id)"
              >
                查看
              </div>
              <div
                class="operation-item item-audit"
                v-if="
                  data.applyStatus === '已申请' &&
                  data.handleStatus === '未处理' &&
                  data.approveStatus === '未审核'
                "
                :class="{ 'item-audit-active': data.audit === '1' }"
                @click="auditPlant(data.id)"
              >
                审核
              </div>
              <div
                class="operation-item item-apply"
                v-if="data.applyStatus === '未申请'"
                @click="applyPlant(data.id)"
              >
                申请
              </div>
            </div>
          </div>
          <div class="none-data" v-if="!loading && tableData.length < 1">
            暂无数据
          </div>
        </div>
        <div class="page-wrapper" v-if="!loading && total > rows">
          <div class="page-wrapper-left">
             共{{ total }}条数据,共{{ Allpages }}页，每页显示{{
              rows
            }}条，当前第{{ page }}页
          </div>
          <div class="page-wrapper-right">
            <div class="page-btn" @click="firstPage">首页</div>
            <div class="page-btn" @click="previousPage">上一页</div>
            <div class="page-btn" @click="Tzpage">跳转至</div>
            <div class="page-btn">
              <input @blur="Tzpage" v-model="page" />
            </div>
            <div class="page-btn" @click="nextPage">下一页</div>
            <div class="page-btn" @click="lastPage">尾页</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropDown from "../../../components/DropDownSingle.vue";
import { queryBoardDetail } from "../../../api/maintain";
export default {
  name: "LookPlant",
  components: { DropDown },
  data() {
    return {
      value: "",
      approveData: [
        { name: "全部", value: "" },
        { name: "未审核", value: 0 },
        { name: "已审核", value: 1 },
      ],
      handleData: [
        { name: "全部", value: "" },
        { name: "未处理", value: 0 },
        { name: "已处理", value: 1 },
      ],
      stackData: [
        { name: "全部", value: "" },
        { name: "需杀虫", value: "01" },
        { name: "正常养护", value: "02" },
      ],
      pestBoardId: "",
      siteName: "",
      loading: true,
      approveStatus: "",
      handleStatus: "",
      startTime: "",
      endTime: "",
      stackStatus: "",
      page: 1,
      rows: 8,
      total: "",
       // 总页数
      Allpages: 0,
      tableData: [],
    };
  },
  created() {
    this.pestBoardId = this.$route.query.pestBoardId;
    this.siteName = this.$route.query.siteName;
    this.handleSearch(1);
  },
  watch: {
    value: function () {
      this.startTime = this.value !== null ? this.value[0] : "";
      this.endTime = this.value !== null ? this.value[1] : "";
    },
  },
  methods: {
    showInfo: function (data) {
      console.log(data);
    },
    showInfoApprove: function (data) {
      this.approveStatus = data.value;
    },
    showInfoHandle: function (data) {
      this.handleStatus = data.value;
    },
    showInfoStack: function (data) {
      this.stackStatus = data.value;
    },
    backPath: function () {
      this.$router.go(-1);
    },
    lookPlantDeal: function (id) {
      this.$router.push({
        path: "/plant/lookPlantDeal",
        query: {
          index: "4",
          pestDetailId: id,
        },
      });
    },
    applyPlant: function (id) {
      this.$router.push({
        path: "/plant/applyPlant",
        query: {
          index: "4",
          pestDetailId: id,
        },
      });
    },
    auditPlant: function (id) {
      this.$router.push({
        path: "/plant/auditPlant",
        query: {
          index: "4",
          pestDetailId: id,
        },
      });
    },
    handleSearch: function (type) {
      if (type === 1) {
        this.page = 1;
      }
      let body = {
        pestBoardId: this.pestBoardId,
        approveStatus: this.approveStatus,
        handleStatus: this.handleStatus,
        startTime: this.startTime,
        endTime: this.endTime,
        stackStatus: this.stackStatus,
        page: this.page,
        rows: this.rows,
      };
      this.loading = true;
      queryBoardDetail(body)
        .then((res) => {
          console.log(res);
          res.data.rows &&
            res.data.rows.map((item) => {
              item.sign = 0;
            });
          this.tableData = res.data.rows || [];
          this.total = res.data.total;
          this.loading = false;
          this.all = false;
          this.idList = [];
           // 计算总页数
          this.Allpages = Math.ceil(this.total / this.rows);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
        this.handleSearch();
      }
    },
    Tzpage: function () {
      console.log("跳转页面");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else if (this.page >= this.Allpages) {
        this.$message({
          message: "总页数为" + this.Allpages,
          type: "warning",
          center: "true",
          duration: "1000",
        });
        this.page = this.Allpages;
        this.handleSearch();
      } else {
        this.handleSearch();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        this.handleSearch();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        this.handleSearch();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        this.handleSearch();
      }
    },
  },
};
</script>

<style scoped>
@import "Plant.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/plant/LookPlant.vue